import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-compass-icon',
  templateUrl: './tools-compass.component.html'
})
export class ToolsCompassComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
